import axios from './axiosInstance';
enum Methods {
    POST = 'post',
    GET = 'get',
    DELETE = 'delete',
    PUT = 'put',
    PATCH = 'patch',
}
type IMethods =
    | Methods.POST
    | Methods.GET
    | Methods.DELETE
    | Methods.PUT
    | Methods.PATCH;
interface CallApiParams {
    method: IMethods;
    url: string;
    data?: object | FormData;
    queryParams?: object;
    config?: object;
}

const callAPI = ({ method, url, data, queryParams, config }: CallApiParams) => {
    let call;
    switch (method) {
        case Methods.GET:
            call = axios.get(url, { ...config, params: queryParams });
            break;
        case Methods.PUT:
            call = axios.put(url, data, { ...config, params: queryParams });
            break;
        case Methods.POST:
            call = axios.post(url, data, { ...config, params: queryParams });
            break;
        case Methods.DELETE:
            call = axios.delete(
                url,
                queryParams ? { params: queryParams } : undefined
            );
            break;
        case Methods.PATCH:
            call = axios.patch(url, data, { ...config, params: queryParams });
            break;
    }

    return call
        .then((response) => ({ response }))
        .catch((error) => {
            return { response: null, error: error?.response };
        });
};

interface IApiParams {
    url: string;
    data?: object | FormData;
    queryParams?: object;
    config?: object;
    headers?: object;
}

export const api = {
    get: ({ url, queryParams, config }: IApiParams) =>
        callAPI({ method: Methods.GET, url, queryParams, config }),
    put: ({ url, data, config, queryParams }: IApiParams) =>
        callAPI({ method: Methods.PUT, url, data, config, queryParams }),
    post: ({ url, data, config, queryParams }: IApiParams) =>
        callAPI({ method: Methods.POST, url, data, config, queryParams }),
    delete: ({ url, queryParams }: IApiParams) =>
        callAPI({ method: Methods.DELETE, url, queryParams }),
    patch: ({ url, data, config, queryParams }: IApiParams) =>
        callAPI({ method: Methods.PATCH, url, data, config, queryParams }),
};
